/**
 인증 관련 이벤트 버스
 @packageDocumentation
 */
import { Route } from 'vue-router'
import { Context } from '@nuxt/types'
import EventBus from '..'

export interface AuthState {
  /**
   * 인증 실패 여부
   */
  failure?: boolean

  /**
   * 로그아웃 여부
   */
  logout?: boolean

  /**
   * 콜백
   */
  callback?: Function

  /**
   * 인증 실패 유형
   *  check : 인증 체크 시 실패 (비로그인) => 화면 인증 체크 실패
   *  expired : 인증 만료 => 서버 401 오류
   *  duplicated: 중복 인증 만료 => 서버 409 오류
   *  released : 인증 해제 => 서버에서 인증 해제된 경우 (로그아웃 포함)
   */
  failureType?: 'check' | 'expired' | 'duplicated' | 'released'

  /**
   * 인증을 실패한 Route
   */
  route?: Route

  /**
   * 컨텍스트 객체
   */
  context?: Context

  /**
   * 서버 오류 발생 시 API URL
   */
  apiUrl?: string
}

export class AuthEventBus extends EventBus<AuthState> {
  name(): string {
    return 'authEventBus'
  }
}

export default new AuthEventBus()
